<template>
  <filtertron-tray-section
    id="field-configurator-access"
    :title="lang.get('fields.configuration.access.label')"
    :initially-collapsed="true"
  >
    <div class="fields island">
      {{ role }}
      <div class="checkbox styled">
        <input
          id="entrant-read-access"
          name="entrantReadAccess"
          type="checkbox"
          :checked="field.entrantReadAccess"
          :disabled="entrantReadAccessDisabled"
          @change="onEntrantReadAccessChecked"
        />
        <label for="entrant-read-access">
          {{ lang.get('fields.form.access.read') }}
        </label>
      </div>
      <div v-if="field.type !== 'content'" class="checkbox styled">
        <input
          id="entrant-write-access"
          name="entrantWriteAccess"
          type="checkbox"
          :checked="field.entrantWriteAccess"
          :disabled="entrantWriteAccessDisabled"
          @change="onEntrantWriteAccessChecked"
        />
        <label for="entrant-write-access">
          {{ lang.get('fields.form.access.write') }}
        </label>
      </div>
      <div v-if="field.type !== 'content'" class="checkbox styled">
        <input
          id="required"
          name="required"
          type="checkbox"
          :checked="field.required"
          :disabled="requiredDisabled"
          @change="onRequiredChecked"
        />
        <label for="required">
          {{ lang.get('fields.form.access.required') }}
        </label>
      </div>
    </div>
  </filtertron-tray-section>
</template>

<script>
import FiltertronTraySection from '@/lib/components/Filtertron/FiltertronTraySection';
import handleInputMixin from '../handle-input-mixin.js';

export default {
  inject: ['lang'],
  components: {
    FiltertronTraySection
  },
  mixins: [handleInputMixin],
  props: {
    field: {
      type: Object,
      required: true
    }
  },
  computed: {
    entrantReadAccessDisabled() {
      return this.field.type !== 'content'
        ? this.field.entrantWriteAccess
        : false;
    },
    entrantWriteAccessDisabled() {
      return false;
    },
    requiredDisabled() {
      return !this.field.entrantReadAccess || !this.field.entrantWriteAccess;
    },
    role() {
      const role = this.lang.get('terms-service.entrant.singular');
      return role ? role[0].toUpperCase() + role.substring(1) : '';
    }
  },
  methods: {
    onEntrantReadAccessChecked(event) {
      this.handleInput('entrantReadAccess', event.target.checked);
    },
    onEntrantWriteAccessChecked(event) {
      const payload = {
        entrantWriteAccess: event.target.checked
      };

      // The entrantWriteAccess selection affects other access settings
      if (!event.target.checked) {
        payload['required'] = false;
      } else {
        payload['entrantReadAccess'] = true;
      }

      this.$emit('input', payload);
    },
    onRequiredChecked(event) {
      this.handleInput('required', event.target.checked);
    }
  }
};
</script>
